import {Injectable} from "@angular/core";
import {Query} from "@datorama/akita";
import {CallingState, StateWebphone, WebphoneStore} from "./webphone.store";

@Injectable({
  providedIn: 'root'
})
export class WebphoneQuery extends Query<StateWebphone> {
  constructor(protected store: WebphoneStore) {
    super(store);
  }

  get isVideoCall() {
    return this.getValue().isVideoCall;
  }

  get callIsProcessing() {
    return this.select(key => key.callState == CallingState.callProcessing);
  }

  get callIsOutgoing() {
    return this.select(key => key.callState == CallingState.callingOut);
  }

  get callIsIncoming() {
    return this.select(key => key.callState == CallingState.callingIn);
  }

  get callIsHolding() {
    return this.select(key => key.callState == CallingState.callHolding);
  }

  get callIsIdle() {
    return this.select(key => key.callState == CallingState.none);
  }

  get portsipErrorCodeListener() {
    return this.select(key => key.errorCode);
  }

  get portsipRegisteredListener() {
    return this.select(key => key.isPortsipRegistered);
  }

  get portsipErrorCode() {
    return this.getValue().errorCode;
  }

  get portsipRegistered() {
    return this.getValue().isPortsipRegistered;
  }

  get currentLocalVideoSrc() {
    return this.getValue().localVideoSrcObject;
  }

  get currentRemoteVideoSrc() {
    return this.getValue().remoteVideoSrcObject;
  }

  get statusCodeEndCall() {
    return this.getValue().statusCodeEndCall;
  }

  get callFunc() {
    return this.getValue().enableCallFunc
  }

}
